module.exports = __webpack_public_path__ + "static/media/withdraw.1fd6fe9d.png";